/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate>): BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate(), model);
        BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate>): BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate.newInstance(<BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
